import React, {useEffect, useState} from 'react';

const HtmlContent = props=>{
    let {content, ...rest} = props;
    let [el, setEl] = useState();
    useEffect(()=>{
        if (!el||!content)
            return;
        el.innerHTML = content;
        return ()=>el.innerHTML = null;
    }, [el, content]);
    return <div ref={setEl} {...rest}></div>;
};

export default HtmlContent;
